import styled from "styled-components";

export const ContainerLoading = styled.div`
    flex: auto;
    display: flex;
`

export const Container = styled.div`
    flex: auto;
    overflow: auto;

    &::-webkit-scrollbar-track {
        background-color: #FFF;
    }

    &::-webkit-scrollbar {
        width: 5px;
    }

    &::-webkit-scrollbar-thumb {
        background: #C3C3C3;
        border-radius: 4px;
    }

    scrollbar-width: thin;
    scrollbar-color: #C3C3C3;
    scrollbar-track-color: #FFF;    

    .seeMore{
        position: absolute;
        top: 0.5rem;
        left: 0.2rem;
        font-size: 1.4rem;
        display: flex;
        color: var(--colorFontsCardsDashboard);

        @media (min-width: 960px){
            cursor: pointer;
        }
    }
`;

export const Content = styled.div`
    margin-bottom: 2.5rem;
`

export const Groups = styled.div`
    color: var(--colorFontsCardsDashboard);
    padding: 1rem 0;
    width: 100%;

    h3{
        margin: 0 0.5rem;
    }
`

export const TableProducts = styled.table`
    border-collapse: collapse;
    margin: 25px 0;
    font-size: 0.9rem;
    width: 100%;


    thead{
        tr{
            background: var(--colorBackgroundCardsDashboard);
            text-align: right;

            th:first-child{
                text-align: left;
            }
        }
    }


    tbody{
        tr{
            border-bottom: 1px solid #DDD;
            text-align: right;
            
            td{
                width: 20%;

                p{
                    margin-top: 10px;
                    text-decoration: underline;
                }
            }
            
            td:first-child{
                text-align: left;
                width: 40%;
            }

            &:nth-child(even){
                background: #f2f2f2;
            }

            &:last-of-type{
                background: #CCC;
                color: black;
                font-weight: 500;
            }
        }
    }


    th, td{
        padding: 0.7rem 0.9rem;
      
    } 
`

export const Button = styled.div`
    padding: 0.5rem;
    border-radius: 5px;
    background: #2e9699;
    color: #FFF;
    margin: 1rem auto;
    max-width: 300px;
    cursor: pointer;
    opacity: ${props => props.loadingButton ? 0.5 : 1};
    pointer-events: ${props => props.loadingButton ? 'none' : 'all'};
    text-align: center;
`